import { useState } from "react";
import BFSignPad from "./BFSignPad";

export default function BFSignSteps({ steps, busy, onDone, onCancel, testid }) {
  const [pngs, setPngs] = useState([]);
  const i = pngs.length;
  const next = (png) => {
    const all = [...pngs, png];
    setPngs(all);
    if (all.length === steps.length) Promise.resolve(onDone(all)).catch(() => setPngs(all.slice(0, -1)));
  };
  return (
    <div className="bf-sign-steps" data-testid={testid}>
      {steps.length > 1 && <span className="bf-sign-step" data-testid={`${testid}-step`}>Semnătura {Math.min(i + 1, steps.length)} din {steps.length}</span>}
      <BFSignPad key={Math.min(i, steps.length - 1)} title={steps[Math.min(i, steps.length - 1)]} busy={busy || i >= steps.length} onSave={next} onCancel={onCancel} testid={`${testid}-pad`} />
    </div>
  );
}

export const signSteps = (admin, fid, firm) => [
  `${admin} · semnează ca administrator${(fid || []).some((g) => g.admin) ? " și fidejusor" : ""} (${firm})`,
  ...(fid || []).filter((g) => !g.admin).map((g) => `${g.nume} · semnează ca fidejusor (${firm})`),
];
